const STRENGTH_HISTORY_CATEGORIES = new Set([
  'strength',
  'powerlifting',
  'plyometrics',
  'olympic weightlifting',
  'strongman',
]);

export const isStrengthHistoryCategory = (category) => {
  const normalized = String(category || '').trim().toLowerCase();
  return STRENGTH_HISTORY_CATEGORIES.has(normalized);
};
